jQuery(function() {
   $('.caret').on('click', function(e){  
   $(this).toggleClass('active');  
 });


  /* Moreview */
  $('.more-views .swiper-slide:first-child').addClass('active');
  $('.thumb-link').click(function() {  
    $('.more-views .swiper-slide').removeClass('active');
    $(this).parent().addClass('active');
  }); 


  if(jQuery('#rev_slider').length > 0)
    jQuery('#rev_slider').show().revolution({
      dottedOverlay: 'none',
      delay: 8000,
      startwidth: 1170,
      startheight: 579,

      hideThumbs:200,
      thumbWidth:100,                            
      thumbHeight:50, 
      thumbAmount:5,

      navigationType:"both",                  
      navigationArrows:"",        
      navigationStyle: 'preview3',             
      touchenabled:"on",                      
      onHoverStop:"on",        

      navOffsetHorizontal:0,
      navOffsetVertical:50,

      swipe_velocity: 0.7, 
      swipe_min_touches: 1,
      swipe_max_touches: 1,
      drag_block_vertical: false,

      spinner: 'spinner2',
      keyboardNavigation: 'on',

      navigationHAlign: 'center',
      navigationVAlign: 'bottom',
      navigationHOffset: 20,
      navigationVOffset: 20,

      soloArrowLeftHalign: '',
      soloArrowLeftValign: '',
      soloArrowLeftHOffset: 0,
      soloArrowLeftVOffset: 0,

      soloArrowRightHalign: '',
      soloArrowRightValign: '',
      soloArrowRightHOffset: 0,
      soloArrowRightVOffset: 0,

      shadow: 0,
      fullWidth: 'on',
      fullScreen: 'on', 

      stopLoop: 'off',
      stopAfterLoops: -1,
      stopAtSlide: -1,

      shuffle: 'off',
      autoHeight: 'on',
      forceFullWidth: 'off',
      hideTimerBar: 'on',

      hideNavDelayOnMobile: 1500,
      hideThumbsOnMobile: 'off',
      hideBulletsOnMobile: 'off',
      hideArrowsOnMobile: 'off',
      hideThumbsUnderResolution: 0,

      hideSliderAtLimit: 0,
      hideCaptionAtLimit: 0,
      hideAllCaptionAtLilmit: 0,
      startWithSlide: 0
    });
  /* End Home Slider */
});

function aweMaps(mapElement) {
  if (! mapElement) {
    mapElement = '#contact-map';
  }

  var map = new GMaps({
    el: mapElement,
    lat: $(mapElement).data('lat'),
    lng: $(mapElement).data('lng'),

    draggable: true,
    scrollwheel: false
  });

  map.addMarker({
    lat: $(mapElement).data('lat'),
    lng: $(mapElement).data('lng'),
  });
}

/* WOW */
wow = new WOW(
  {
    animateClass: 'animated',
    offset:       100,
    callback:     function(box) {
      console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
    }
  }
);
wow.init();


/* Back to top */
$(window).scroll(function () {
  if ($(this).scrollTop() > 50) {
    $('.back-to-top').addClass('show');
  } else {
    $('.back-to-top').removeClass('show');
  }
});


$( window ).load(function() {
  /* Page loader */
  $( 'body' ).addClass( 'loaded' );
  setTimeout(function () {
    $('#pageloader').fadeOut();
  }, 500);
});

(function($) {
  "use strict";
  $(document).ready(function() {

    /* Back to top */
    $('.back-to-top').on( 'click', function(e) {
      e.preventDefault(); 
      $("html, body").animate({
        scrollTop: 0
      }, 500);
    });


    /* OWL carousel */
    $(".owl-carousel-play .owl-carousel").each( function(){
      var config = {
        loop: $(this).data('loop'),
        nav: $(this).data('nav'),
        navText: ["<i class='fa fa-long-arrow-left'></i>","<i class='fa fa-long-arrow-right'></i>"], 
        margin: $(this).data('margin'),
        items: $(this).data('items'),
        lazyLoad : $(this).data('lazyLoad'),        
        dots: $(this).data('dots'),         
        autoHeight: $(this).data('autoHeight'),
        responsiveClass:true,
        responsive:{
          320:{
            items:1,
            nav:true
          },
          360:{
            items:1,
            nav:true
          },
          480:{
            items:1,
            nav:true
          },
          481:{
            items:$(this).data('xs-items')       
          },
          768:{
            items:$(this).data('sm-items')       
          },
          993:{
            items:$(this).data('md-items')       
          },
          1400:{
            items:6       
          }

        }
      };
      $(this).owlCarousel( config );        
    });


    $(".owl-carousel-colection .owl-carousel").each( function(){
      var config = {
        loop: $(this).data('loop'),
        nav: $(this).data('nav'),
        navText: ["<i class='fa fa-long-arrow-left'></i>","<i class='fa fa-long-arrow-right'></i>"], 
        margin: $(this).data('margin'),
        items: $(this).data('items'),
        lazyLoad : $(this).data('lazyLoad'),        
        dots: $(this).data('dots'),         
        autoHeight: $(this).data('autoHeight'),
        responsiveClass:true,
        responsive:{
          320:{
            items:1,
            nav:true
          },
          360:{
            items:1,
            nav:true
          },
          480:{
            items:1,
            nav:true
          },
          481:{
            items:$(this).data('xs-items')       
          },
          768:{
            items:$(this).data('sm-items')       
          },
          993:{
            items:$(this).data('md-items')       
          }

        }
      };
      $(this).owlCarousel( config );        
    });

    /* OWL carousel */
    $(".owl-carousel-blog .owl-carousel").each( function(){
      var config = {
        loop: $(this).data('loop'),
        nav: $(this).data('nav'),
        navText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"], 
        margin: $(this).data('margin'),
        items: $(this).data('items'),
        lazyLoad : $(this).data('lazyLoad'),        
        dots: $(this).data('dots'),         
        autoHeight: $(this).data('autoHeight'),
        responsiveClass:true,
        responsive:{
          0:{
            items:1,
            nav:true
          },
          480:{
            items:$(this).data('xs-items')       
          },
          530:{
            items:$(this).data('sm-items')       
          },
          992:{
            items:$(this).data('items')       
          }

        }
      };
      $(this).owlCarousel( config );        
    });


    /* OWL carousel */
    $(".owl-carousel-product .owl-carousel").each( function(){
      var config = {
        loop: $(this).data('loop'),
        nav: $(this).data('nav'),
        navText: ["<i class='fa fa-long-arrow-left'></i>","<i class='fa fa-long-arrow-right'></i>"], 
        margin: $(this).data('margin'),
        items: $(this).data('items'),
        lazyLoad : $(this).data('lazyLoad'),        
        dots: $(this).data('dots'),         
        autoHeight: $(this).data('autoHeight'),
        responsiveClass:true,
        responsive:{
          320:{
            items:1,
            nav:true
          },
          360:{
            items:1,
            nav:true
          },
          480:{
            items:1,
            nav:true
          },
          481:{
            items:$(this).data('xs-items')       
          },
          768:{
            items:$(this).data('sm-items')       
          },
          993:{
            items:$(this).data('md-items')       
          }

        }
      };
      $(this).owlCarousel( config );        
    });

    /* OWL carousel */
    $(".owl-carousel-brand .owl-carousel").each( function(){
      var config = {
        loop: $(this).data('loop'),
        nav: $(this).data('nav'),
        navText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"], 
        margin: $(this).data('margin'),
        items: $(this).data('items'),
        lazyLoad : $(this).data('lazyLoad'),        
        dots: $(this).data('dots'),         
        autoHeight: $(this).data('autoHeight'),
        responsiveClass:true,
        responsive:{
          0:{
            items:1,
            nav:true
          },
          480:{
            items:$(this).data('xs-items')       
          },
          530:{
            items:$(this).data('sm-items')       
          },
          981:{
            items:$(this).data('items')       
          }

        }
      };
      $(this).owlCarousel( config );        
    });

    /* Tabs */
    $(".e-tabs").each( function(){
      $(this).find('.tabs-title li:first-child').addClass('current');
      $(this).find('.tab-content').first().addClass('current');

      $(this).find('.tabs-title li').click(function(){
        var tab_id = $(this).attr('data-tab');

        var url = $(this).attr('data-url');
        $(this).closest('.e-tabs').find('.tab-viewall').attr('href',url);

        $(this).closest('.e-tabs').find('.tabs-title li').removeClass('current');
        $(this).closest('.e-tabs').find('.tab-content').removeClass('current');

        $(this).addClass('current');
        $(this).closest('.e-tabs').find("#"+tab_id).addClass('current');
      });    

    });
    /*  [ Tabs ]
        - - - - - - - - - - - - - - - - - - - - */
    $( '.tabs-container' ).each(function() {
      $( this ).find( '.tabs li:first-child a' ).addClass('active');
      $( this ).find( '.tab-content:first' ).show();

      $( this ).find('.tabs li a').on( 'click' , function(e) {
        e.preventDefault();
        var selector = $(this).attr('href');
        $(this).parent().parent().find('a').not(this).removeClass('active');
        $(this).addClass('active');
        $(this).parents('.tabs-container').find('.tab-content').not(selector).slideUp(300);
        $(this).parents('.tabs-container').find(selector).slideDown(300);
      });
    });
    /*  [ Home 7 Slide Controls ]
        - - - - - - - - - - - - - - - - - - - - */
    var count = $( '.parallax-section li' ).length;
    $( '.parallax-count .count' ).html( '<em>1/</em>' + count );
    $( '.parallax-section li' ).each(function(index) {
      var pos = $( this ).offset().top + $( this ).outerHeight();
      var _this = $( this );
      $( window ).scroll(function(event) {
        if ( $( window ).scrollTop() >= $( _this ).offset().top ) {
          $( '.parallax-count .count' ).html('<em>' + (index + 1) + '</em>' + '/' + count);
        };
      });
    });        
    $( '.parallax-count .prev' ).on( 'click', function(e) {
      e.preventDefault();
      var _index = parseInt($( '.parallax-count .count em' ).text(), 10) - 1;
      if(_index != 0){
        var _posPrev = $( '.parallax-section li' ).eq(_index-1).offset().top;
        $("html, body").animate({
          scrollTop: _posPrev
        }, 500);
      }
    });
    $( '.parallax-count .next' ).on( 'click', function(e) {
      e.preventDefault();
      var _index = parseInt($( '.parallax-count .count em' ).text(), 10) - 1;
      if(_index < count){
        var _posNext = $( '.parallax-section li' ).eq(_index+1).offset().top;
        $("html, body").animate({
          scrollTop: _posNext
        }, 500);
      }
    });

    /*  [ currency ]
        - - - - - - - - - - - - - - - - - - - - */
    $('.fix-currency').each(function () {
      var cur = $('select.currency-picker');

      cur.parent().append('<div class="sub-curency"><ul class="currency-picker" name="currency-picker"></ul></div>');
      cur.parent().append('<a class="currency-label" href="#" title=""></a>');
      cur.css('display','none');

      $('.currency-label').html($('select.currency-picker').val());
      $('.currency-picker option').each(function(){
        $('.currency-picker').append('<li value="' + $(this).val() + '">'+$(this).text()+'</li>');
      });

      $('ul.currency-picker li').click(function(){
        var val =$(this).attr('value');
        cur.val(val).change();   
        $('.currency-label').html(val);
      })    

    });
    $(document).on('click','.overlay,.continue-shopping, .close-window', function() {   
      hidePopup('.engo-popup'); 

      setTimeout(function(){
        $('.loading').removeClass('loaded-content');
      },500);
      return false;
    });

    /*  [ Popup ]
        - - - - - - - - - - - - - - - - - - - - */
    $( '.popup-close' ).on( 'click', function(e) {
      e.preventDefault();
      $( this ).parents( '.popup' ).removeClass( 'popup-open' );
    });

    /*  [ Burger Menu ]
         - - - - - - - - - - - - - - - - - - - - */
    $( '.burger-control' ).on( 'click', function(e) {
      e.preventDefault();
      $( '#popup-burger' ).addClass( 'popup-open' );
    });

    /*  [ Mouse click scroll down ]         - - - - - - - - - - - - - - - - - - - - */
    $( '.mouse-scroll' ).on( 'click', function(e) {
      e.preventDefault();
      $("html, body").animate({
        scrollTop: $( window ).height()
      }, 700, function() {
        $('.sticky-wrapper').addClass('is-sticky');
      });
    });

    /* Tag */
    var minfontSize = 10;
    var maxfontSize = 24;

    $('.block-blog-tags').find('a').each(function(e){
      $(this).css("font-size", randumNumber(minfontSize, maxfontSize));
    });

    function randumNumber(min, max){
      return Math.floor(Math.random()*(max-min+1)+min);
    }
    $(window).scroll(function () {
      if ($(this).scrollTop() >1) {
        $('.header-v2').addClass('sticky-header2');
      } else {
        $('.header-v2').removeClass('sticky-header2');
      }
    });
    $(window).scroll(function () {
      if ($(this).scrollTop() > 667) {
        $('.header-v3').addClass('is-sticky');
      } else {
        $('.header-v3').removeClass('is-sticky');
      }
    });
    $(window).scroll(function () {
      if ($(this).scrollTop() > 65) {
        $('.header-v4').addClass('sticky-header4');
      } else {
        $('.header-v4').removeClass('sticky-header4');
      }
    });
    /*  [ Page loader ]
            - - - - - - - - - - - - - - - - - - - - */
    $( 'body' ).addClass( 'loaded' );
    setTimeout(function () {
      $('#pageloader').fadeOut();
    }, 500);
    /*  [ Back to top ]
        - - - - - - - - - - - - - - - - - - - - */
    $(window).scroll(function () {
      if ($(this).scrollTop() > 50) {
        $('.back-to-top').addClass('show');
      } else {
        $('.back-to-top').removeClass('show');
      }
    });
    $('.back-to-top').on( 'click', function(e) {
      e.preventDefault();
      $("html, body").animate({
        scrollTop: 0
      }, 500);
    });

    var tesimonial = new Swiper('.testimonial-content-gallery', {
      loop:true,
      centeredSlides: true,
      loopedSlides: 5 //looped slides should be the same
    });
    var tesimonialThumbs = new Swiper('.testimonial-thumbs', {
      slidesPerView: 5,
      touchRatio: 0.2,
      loop:true,
      centeredSlides: true,
      loopedSlides: 5, //looped slides should be the same
      breakpoints: {
        // when window width is <= 320px
        320: {
          slidesPerView: 3,
          spaceBetweenSlides: 10
        },
        // when window width is <= 480px
        480: {
          slidesPerView: 3,
          spaceBetweenSlides: 20
        },
        // when window width is <= 768px
        768: {
          slidesPerView: 3,

        },
      },
      slideToClickedSlide: true
    });
    tesimonial.params.control = tesimonialThumbs;
    tesimonialThumbs.params.control = tesimonial;
  });
  
  
})(jQuery);




